export function getFaviconEl(): HTMLLinkElement {
  return document.getElementById('favicon') as HTMLLinkElement;
}

export function changeFavicon(url: string) {
  const favicon = getFaviconEl();
  favicon.href = url;
}
